import { render, staticRenderFns } from "./MakeDefaultwallet.vue?vue&type=template&id=5bbc20c7&scoped=true"
import script from "./MakeDefaultwallet.vue?vue&type=script&lang=js"
export * from "./MakeDefaultwallet.vue?vue&type=script&lang=js"
import style0 from "./MakeDefaultwallet.vue?vue&type=style&index=0&id=5bbc20c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc20c7",
  null
  
)

export default component.exports